import {
  FormBase,
  type ITemplateType,
  SearchBar,
  SelectData,
} from '@gbs-monorepo-packages/common';

import {
  SearchBarContainer,
  SearchTemplatesContainer,
  SearchTypeContainer,
} from './styles';

export interface ISearchTemplatesProps {
  dataCyPrefix: string;
  labelPrefix: string;
  templateTypeData: ITemplateType[];
  currentTemplateType: number;
  onChangeTemplateType: (value: number) => void;
  currentSearch: string;
  onChangeSearchData: (search: string) => void;
  onClearSearchData: () => void;
  onOpenChange?: (isOpen: boolean) => void;
  handleOpenChange: (open: boolean, template: string) => void;
  isSearching?: boolean;
  maxLength?: number;
}

export const SearchTemplates = ({
  dataCyPrefix,
  labelPrefix,
  templateTypeData,
  currentTemplateType,
  onChangeTemplateType,
  currentSearch,
  onChangeSearchData,
  onClearSearchData,
  handleOpenChange,
  isSearching = false,
  maxLength,
}: ISearchTemplatesProps): JSX.Element => {
  return (
    <SearchTemplatesContainer>
      <SearchTypeContainer>
        <FormBase.InputContent
          filled
          label={`${labelPrefix} Type`}
          inputRef={`${dataCyPrefix}-type-select`}
          isSelectData
        >
          <SelectData
            dataCy="select-templateType"
            data={templateTypeData}
            value={currentTemplateType.toString()}
            onOpenChange={(isOpen) => {
              handleOpenChange(isOpen, 'courseTemplate');
            }}
            placeholder={`
            Select ${labelPrefix} Type
          `}
            onValueChange={(value) => {
              onChangeTemplateType(Number(value));
            }}
            required
          />
        </FormBase.InputContent>
      </SearchTypeContainer>
      <SearchBarContainer>
        <SearchBar
          search={currentSearch}
          onChange={(e) => {
            onChangeSearchData(e.target.value);
          }}
          onClearInput={onClearSearchData}
          loading={isSearching}
          dataCy={dataCyPrefix}
          maxLength={maxLength}
        />
      </SearchBarContainer>
    </SearchTemplatesContainer>
  );
};
